import React from 'react';
import { Login, LoginForm } from 'react-admin';
import { Box, Card, CardContent, Typography, Avatar, IconButton, Tooltip } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const MyLoginForm = (props) => {
  const handleBackToHome = () => {
    // Recharger la page pour revenir à l'état initial de l'application
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        position: 'relative',
      }}
    >
      {/* Bouton de retour en haut à gauche */}
      <Box
        sx={{
          position: 'absolute',
          top: 20,
          left: 20,
        }}
      >
        <Tooltip title="Retour à la page d'accueil">
          <IconButton
            onClick={handleBackToHome}
            sx={{
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Card sx={{ minWidth: 300, maxWidth: 400, p: 2 }}>
        <CardContent>
          <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <Avatar sx={{ m: 1, bgcolor: 'primary.main', width: 56, height: 56 }}>
              <StorefrontIcon fontSize="large" />
            </Avatar>
            <Typography component="h1" variant="h4" align="center" gutterBottom>
              MyAdmin
            </Typography>
            <Typography variant="subtitle1" align="center" color="textSecondary">
              La Ferme À L'Ancienne
            </Typography>
          </Box>
          <LoginForm {...props} />
          <Box mt={2}>
            <Typography variant="caption" display="block" align="center" color="textSecondary">
              Utilisateur: Jmaudet | Mot de passe: mjerome2000
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export const MyLoginPage = (props) => (
  <Login {...props}>
    <MyLoginForm />
  </Login>
);